import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const capacityRoute: InvariantJiraRoute = {
	name: 'servicedesk-capacity',
	path: '/jira/servicedesk/projects/:projectKey/capacity',
	exact: true,
};
